import React from 'react';
import { useSelector } from 'react-redux';

import Hopper from './Hopper'
import Compositor from '../composite/Compositor';
import './Hop.css';
import './Hop1.css';
import HopSettingsForm from './HopSettingsForm';

const Hop = () => {
  const { peerVideoLayout } = useSelector((state) => state.webrtcMeeting);

  return (
    <div className="row justify-content-center hop-page">
      <div style={{display:'none'}}>
        <Compositor />
      </div>
      {/* Thêm class động vào container video */}
      <div className="col-md-8 col-sm-12">
        <div id="peer-video-container" className={peerVideoLayout}>
          <Hopper />
        </div>
      </div>
      <HopSettingsForm />
    </div>
  );
}

export default Hop;
